export default __webpack_public_path__ + "static/media/G0650-Electrical-injury-algorithm.1721738220000.5d82b6e1.jpg";